import { Validable, ValidationResult } from "../../../utils/Validable";

export default class Account implements Validable {
	public id?: number;
	public version: number;
	public name: string;
	public accountNumber: string;
	public description?: string;
	
	constructor(name: string, accountNumber: string, version: number = 1) {
		this.name = name;
		this.accountNumber = accountNumber;
		this.version = version;
	}

	validate(fieldName: string): ValidationResult {
		let vr: ValidationResult = {
			isValid: true,
			validationMessage: ""
		}
		if(fieldName === "name") {
			if(!this.name || !this.name.trim()) {
				vr = {
					...vr,
					isValid: false,
					validationMessage: "Mandatory field"
				}
			}
		} 
		else if(fieldName === "accountNumber") {
			if(!this.accountNumber || !this.accountNumber.trim()) {
				vr = {
					...vr,
					isValid: false,
					validationMessage: "Mandatory field"
				}
			}
		}
		return vr;
	}
	validateAll(): ValidationResult {
		let vr: ValidationResult = {
			isValid: true,
			validationMessage: ""
		}
		if(!this.validate("name").isValid) {
			vr = {
				isValid: false,
				validationMessage: "errors in form"
			}
		}
		else if(!this.validate("accountNumber").isValid) {
			vr = {
				isValid: false,
				validationMessage: "errors in form"
			}
		}
		return vr;
	}
	clone() {
		let account: Account = new Account(this.name, this.accountNumber, this.version);
		account.id = this.id;
		account.description = this.description;
		return account;
	}

	get displayName() {
		return this.validateAll().isValid? [this.name, this.accountNumber].join(" - ") : "New account" 
	}
}
